import { motion, useReducedMotion } from 'motion/react'

interface RevealProps {
  children: React.ReactNode
  className?: string
  delay?: number
  style?: React.CSSProperties
}

export function Reveal({ children, className, delay = 0, style }: RevealProps) {
  const reduced = useReducedMotion()

  if (reduced) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    )
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 20 }}
      style={style}
      transition={{ delay, duration: 0.4, ease: 'easeOut' }}
      viewport={{ margin: '-40px', once: true }}
      whileInView={{ opacity: 1, y: 0 }}
    >
      {children}
    </motion.div>
  )
}
